import { useTranslation } from 'react-i18next';
import Container from 'react-bootstrap/Container';
import { Navbar, Nav } from 'react-bootstrap';

import styles from './styles.module.css';
import { isRTL } from 'src/utils/global';
import LangMenu from 'src/components/LangMenu/LangMenu';

const NavLarge = () => {
    const { t } = useTranslation("common");

    return (
        <header>
            <Navbar className={`${styles.nav} ${isRTL() && styles.rtl}`}>
                <Navbar.Brand className={styles.nav__brand} href="/">
                    {t("nav.title")}
                </Navbar.Brand>

                <Nav className={styles.lang_btn_con}>
                    <LangMenu />
                </Nav>
            </Navbar>
        </header>
    );
};

export default NavLarge;
